const COLORS = ['#004D40', '#71bd48', '#01579B', '#006064', '#00796B', '#0097A7', '#0288D1', '#26A69A', '#26C6DA', '#29B6F6', '#4CAF50', '#66BB6A']

const FONT = '12px Tajawal, Arial Unicode MS, sans-serif'
const BOX_SIZE = 12
const BOX_TEXT_GAP = 8
const ROW_H = 30
const PADDING = 16
const MIN_COL_GAP = 24

/**
 * Captures an ApexCharts component image and appends a properly-spaced legend.
 * @param {object} apexRef - ref to the <apexchart> component
 * @param {string[]} labels - legend labels
 * @param {string[]} [colors] - colour palette (defaults to COLORS)
 */
export async function captureWithLegend(apexRef, labels, colors = COLORS) {
    const { imgURI } = await apexRef.chart.dataURI()
    return buildImageWithLegend(imgURI, labels, colors)
}

/**
 * Combines a chart PNG data-URI with a dynamically laid-out legend canvas.
 */
export function buildImageWithLegend(chartURI, labels, colors = COLORS) {
    return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
            // --- measure the widest label ---
            const tmpCanvas = document.createElement('canvas')
            const tmpCtx = tmpCanvas.getContext('2d')
            tmpCtx.font = FONT
            const maxTextWidth = labels.reduce((max, l) => {
                const w = tmpCtx.measureText(l).width
                return w > max ? w : max
            }, 60)

            const itemW = BOX_SIZE + BOX_TEXT_GAP + maxTextWidth + MIN_COL_GAP
            const availableW = img.width - PADDING * 2
            const itemsPerRow = Math.max(1, Math.floor(availableW / itemW))
            const colW = availableW / itemsPerRow

            const rows = Math.ceil(labels.length / itemsPerRow)
            const legendH = rows * ROW_H + PADDING * 2

            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height + legendH
            const ctx = canvas.getContext('2d')

            // white background + chart
            ctx.fillStyle = '#FFFFFF'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, 0, 0)

            // legend items
            ctx.font = FONT
            ctx.direction = 'rtl'

            labels.forEach((label, i) => {
                const col = i % itemsPerRow
                const row = Math.floor(i / itemsPerRow)
                const x = PADDING + col * colW
                const y = img.height + PADDING + row * ROW_H

                // colour square
                ctx.fillStyle = colors[i % colors.length]
                ctx.fillRect(x, y, BOX_SIZE, BOX_SIZE)

                // label text
                ctx.fillStyle = '#263238'
                ctx.textAlign = 'left'
                ctx.fillText(label, x + BOX_SIZE + BOX_TEXT_GAP, y + 10)
            })

            resolve(canvas.toDataURL('image/jpeg', 0.9))
        }
        img.onerror = () => resolve(chartURI)
        img.src = chartURI
    })
}

export { COLORS }
